module.exports = __webpack_public_path__ + "media/images/lb/535-bad97e63667b207b0c5aa6db64054896.svg";